<template>
  <span class="loading-placeholder" :style="{ width, height }"></span>
</template>
<script>
export default {
  name: 'loading-placeholder',
  props: {
    width: {
      type: String,
      default: '60px'
    },
    height: {
      type: String,
      default: '1em'
    }
  }
}
</script>
